import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Components/Home/Home";
import PreviewProduct from "./Components/ProductPage/PreviewProduct";
import Cart from "./Components/CartPage/Cart";
import Adresse from "./Components/Adresse/Adresse";
import Categorie from "./Components/Categorie/Categorie";
import PromosPage from "./Components/Promos/PromosPage";
import SearchPage from "./Components/Search/SearchPage";
import Contact from "./Components/Contact/Contact";
import LoginContent from "./Admin/Login/Login";
import DashboardLayout from "./Admin/Dashboard/DashboardLayout/DashboardLayout";
import ShowProducts from "./Admin/Dashboard/Content/Product/ShowProducts";
import AddProduct from "./Admin/Dashboard/Content/Product/AddProduct";
import DashboardHome from "./Admin/Dashboard/DashboardLayout/DashboardHome";
import ShowCategories from "./Admin/Dashboard/Content/Category/ShowCategories";
import AddCategory from "./Admin/Dashboard/Content/Category/AddCategory";
import EditCategory from "./Admin/Dashboard/Content/Category/EditCategory";
import EditProduct from "./Admin/Dashboard/Content/Product/EditProduct";
import ProtectedRoute from "./Admin/ProtectedRoute/ProtectedRoute"; // Import the gatekeeper
import NosProducts from "./Components/Products/NosProducts";
import Orders from "./Admin/Dashboard/Content/Orders/Orders";
import Sliders from "./Admin/Dashboard/Content/Sliders/Sliders";
import ConditionsGenerales from "./Components/ConditionsGenerales/ConditionsGenerales";
import Faq from "./Components/ConditionsGenerales/Faq";
import SousCategory from "./Admin/Dashboard/Content/Category/SousCategory";
import ShowSousCategory from "./Admin/Dashboard/Content/Category/ShowSousCategory";
import EditSousCategory from "./Admin/Dashboard/Content/Category/EditSousCategory";
import SousCategorie from "./Components/Categorie/SousCategorie/SousCategorie";
import { HelmetProvider } from "react-helmet-async"; // Added

function App() {
  return (
    <div className="App">

      <HelmetProvider> {/* Wrapped here */}
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:slug" element={<PreviewProduct />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/adresse" element={<Adresse />} />
            <Route path="/categorie/:categorie" element={<Categorie />} />
            <Route path="/categorie/:categorie/:sousCategorie" element={<SousCategorie />} />
            <Route path="/nos-promos" element={<PromosPage />} />
            <Route path="/nos-produits" element={<NosProducts />} />
            <Route path="/search/:search" element={<SearchPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/conditions-generales" element={<ConditionsGenerales />} />
            <Route path="/faq" element={<Faq />} />

            {/* login admin page */}
            <Route path="/admin" element={<LoginContent />} />

            {/* PROTECTED ADMIN ROUTES */}
            <Route element={<ProtectedRoute />}>
              <Route path="/admin/dashboard" element={<DashboardLayout />}>
                <Route index element={<DashboardHome />} />
                <Route path="products" element={<ShowProducts />} />
                <Route path="add-product" element={<AddProduct />} />
                <Route path="categories" element={<ShowCategories />} />
                <Route path="add-category" element={<AddCategory />} />
                <Route path="edit-category/:id" element={<EditCategory />} />
                <Route path="add-sous-category" element={<SousCategory />} />
                <Route path="sous-category" element={<ShowSousCategory />} />
                <Route path="edit-sous-category/:id" element={<EditSousCategory />} />
                <Route path="edit-product/:id" element={<EditProduct />} />
                <Route path="orders" element={<Orders />} />
                <Route path="sliders" element={<Sliders />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </HelmetProvider>

    </div>
  );
}

export default App;
